import { Component, ViewChild } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatInput } from '@angular/material/input';
import { AbstractCellEditor, CustomCellEditorParams } from '@app/shared/components/cell-edit/abstract.cell-editor';
import { provideDayjsDateAdapter } from '@app/shared/extra/dayjs-date-adapter';
import dayjs from 'dayjs';

@Component({
  selector: 'date-cell-edit',
  templateUrl: './date-cell-edit.component.html',
  styleUrls: ['./date-cell-edit.component.scss'],
  providers: [provideDayjsDateAdapter()],
  standalone: false
})
export class DateCellEditComponent extends AbstractCellEditor {
  @ViewChild(MatInput, {static: false}) public input: MatInput;
  @ViewChild(MatDatepicker, {static: true}) public datePicker: MatDatepicker<any>;

  /**
   * Initialisation method for the render component
   * @param params A merge of default cell editor params and custom params
   */
  public agInit(params: CustomCellEditorParams): void {
    super.agInit(params);
    // Input must be a dayjs compatible value
    const date = dayjs(this.params.value, this.appConfig.DATE_FORMAT);
    this.control.setValue(date.isValid() ? date : null);
  }

  /**
   *  A hook to perform any necessary operation just after the GUI for this component has been rendered on the screen.
   *  This method is called each time the edit component is activated.
   */
  public afterGuiAttached(): void {
    this.input.focus();
  }

  /**
   * Return the final value - called by the grid once after editing is complete
   */
  public getValue(): any {
    return dayjs(this.control.value).isValid() ? dayjs(this.control.value).format(this.appConfig.DATE_FORMAT) : '';
  }

  public dateChange(): void {
    if (this.control.valid) {
      this.stopEditing();
    }
  }

  /**
   * Update tooltip message in case of validation error
   * @param type Type of the validator in error
   * @param definition Definition of the validator in error
   */
  protected setTooltip(type: string, definition: string | number): void {
    const formattedDefinition = dayjs(definition || '').isValid() ? dayjs(definition).format(this.appConfig.DATE_FORMAT) : definition;
    this.errorTooltip = this.translateService.instant(
      `ERROR.FIELD_${type}`.toUpperCase(),
      {value: formattedDefinition}
    );
  }
}
